<template>
  <v-select
    v-if="!nameSchema.$disabled"
    label-field="name"
    value-field="name"
    :no-options-text="emptyListMsg"
    :disabled="disabled"
    :model="nameSchema"
    :values="jstList"
    :ajax="true"
    @input="selectedJst"
    @search="search"
  />
</template>

<script>
import axios from 'axios';

import vSelect from './vue-select.vue';
import debounceMixin from '../mixins/debounceMixin';

// @vuese
// Komponent wyboru JST na podstawie przesłanego terca
// @group components
export default {
  name: 'WJstPicker',
  components: {
    vSelect
  },
  mixins: [debounceMixin],
  props: {
    // URL do TERYT API
    url: {
      type: String,
      required: false,
      default: 'https://teryt.api.witkac.pl'
    },
    // Schema
    model: {
      type: Object,
      required: false
    },
    // Schema nazwy JST
    nameModel: {
      type: Object,
      required: false
    },
    // Schema dodatkowych pól do pobrania
    dataModel: {
      type: Object,
      required: false
    },
    // Wiadomość kiedy lista JST jest pusta
    emptyListMsg: {
      type: String,
      required: false,
      default: 'Nie znaleziono pasujących jednostek samorządu terytorialnego'
    },
    // Czy pole wyboru JST jest zablokowane
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // Terc po którym wyszukuje urzędy - String od 2 do 6 znaków
    terc: {
      type: String,
      required: false,
      default: ''
    },
    // Terc do autowyszukania przy zamontowaniu elementu
    tercForAutocomplete: {
      type: String,
      required: false
    },
    // Czas w ms do debounce
    debounceTime: {
      type: Number,
      required: false,
      default: 200
    },
    // Czy pokazywać błędy
    showError: { type: Boolean, default: true }
  },
  data() {
    return { jstList: [] };
  },
  computed: {
    extraFields() {
      return (this.dataSchema && Object.keys(this.dataSchema.$model)) || [];
    },
    nameSchema() {
      return this.nameModel || this.model.name;
    },
    dataSchema() {
      return this.dataModel || this.model.data;
    }
  },
  watch: {
    terc(value) {
      this.clearPicker();
      if (value.length >= 6) {
        this.getJstList();
      }
    }
  },
  mounted() {
    if (this.nameSchema.$model || this.terc || this.tercForAutocomplete) {
      this.search(this.nameSchema.$model, this.terc || this.tercForAutocomplete);
    }
  },
  methods: {
    // @vuese
    // Wybór Jednostki Samorządu Terytorialnego
    // @arg `value` - Nazwa jednostki samorządu
    selectedJst(picked) {
      if (!picked) {
        return this.clearPicker();
      }

      this.nameSchema.$setData(picked.name);
      if (this.dataSchema) {
        this.dataSchema.$setData(picked);
      }
      this.$emit('change', picked);
    },
    // @vuese
    // Wyszukiwanie wprowadzonej nazwy w bazie
    // @arg `name` - Fragment tekstu do wyszukania
    search(searchText, terc) {
      this.debounce(this.getJstList, this.debounceTime)(searchText, terc || this.terc);
    },
    // @vuese
    // Pobranie listy JST
    // @arg `value` - TERC
    getJstList(search, terc) {
      return axios
        .get(`${this.url}/contact`, {
          params: {
            fields: ['name', ...this.extraFields].join(','),
            search,
            terc
          }
        })
        .then(response => response.data.list)
        .then(array => {
          this.$set(this, 'jstList', array);
          if (this.jstList.length === 1) {
            this.selectedJst(this.jstList[0]);
          }
        })
        .catch(error => this.$emit('error', 'Nie udało się pobrać listy jednostek samorządu terytorialnego'));
    },
    // @vuese
    // Czyści pickera
    clearPicker() {
      this.$set(this, 'jstList', []);
      this.nameSchema.$setData(null);
      if (this.dataSchema) {
        Object.keys(this.dataSchema.$model).forEach(key => this.dataSchema[key].$setData(null));
      }
      this.$emit('change', null);
    }
  }
};
</script>
